import request from './base'

export const login = (params) => {
    return request.post("/admin/v1/login", params)
}



// WEBPACK FOOTER //
// ./src/api/login.js